export const SUPPORT_EMAIL = 'contact@blindbook.com'
